import React from "react";

export default function ProductVisibility({
    product,
    setProduct
}) {

    const update = (field, value) => {

        setProduct(prev => ({
            ...prev,
            [field]: value
        }));

    };

    return (

        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: 24
            }}
        >

            <div>

                <h2
                    style={{
                        margin: 0
                    }}
                >
                    Visibility
                </h2>

                <p
                    style={{
                        color: "#666",
                        marginTop: 8
                    }}
                >
                    Control publication status and who can see
                    this product.
                </p>

            </div>

            <div
                style={{
                    background: "#fff",
                    borderRadius: 16,
                    padding: 24,
                    border: "1px solid #e5e7eb",
                    display: "grid",
                    gridTemplateColumns:
                        "repeat(auto-fit,minmax(240px,1fr))",
                    gap: 20
                }}
            >

                <div>

                    <label>Status</label>

                    <select
                        value={
                            product.status || "draft"
                        }
                        onChange={e =>
                            update(
                                "status",
                                e.target.value
                            )
                        }
                        style={inputStyle}
                    >

                        <option value="draft">
                            Draft
                        </option>

                        <option value="published">
                            Published
                        </option>

                        <option value="hidden">
                            Hidden
                        </option>

                        <option value="archived">
                            Archived
                        </option>

                    </select>

                </div>

                <div>

                    <label>Visibility</label>

                    <select
                        value={
                            product.visibility || "public"
                        }
                        onChange={e =>
                            update(
                                "visibility",
                                e.target.value
                            )
                        }
                        style={inputStyle}
                    >

                        <option value="public">
                            Public
                        </option>

                        <option value="followers">
                            Followers
                        </option>

                        <option value="private">
                            Private
                        </option>

                    </select>

                </div>

            </div>

            <div
                style={{
                    background: "#fff",
                    borderRadius: 16,
                    padding: 24,
                    border: "1px solid #e5e7eb",
                    display: "flex",
                    flexDirection: "column",
                    gap: 18
                }}
            >

                <Toggle
                    label="Featured Product"
                    description="Highlight this product in your brand storefront."
                    checked={!!product.featured}
                    onChange={value =>
                        update("featured", value)
                    }
                />

                <Toggle
                    label="Digital Product"
                    description="Mark this product as a digital product."
                    checked={!!product.isDigital}
                    onChange={value =>
                        update("isDigital", value)
                    }
                />

            </div>

        </div>

    );

}

function Toggle({
    label,
    description,
    checked,
    onChange
}) {

    return (

        <label
            style={{
                display: "flex",
                alignItems: "flex-start",
                gap: 14,
                cursor: "pointer"
            }}
        >

            <input
                type="checkbox"
                checked={checked}
                onChange={e =>
                    onChange(e.target.checked)
                }
                style={{
                    marginTop: 4
                }}
            />

            <span>

                <strong>
                    {label}
                </strong>

                <div
                    style={{
                        color: "#777",
                        fontSize: 14,
                        marginTop: 4
                    }}
                >
                    {description}
                </div>

            </span>

        </label>

    );

}

const inputStyle = {

    width: "100%",
    boxSizing: "border-box",
    marginTop: 8,
    padding: "12px 14px",
    borderRadius: 10,
    border: "1px solid #d1d5db",
    fontSize: 15,
    background: "#fff"

};